import {AppBar, IconButton, Stack, Toolbar, Typography} from "@mui/material";
import {VscSignOut} from "react-icons/vsc";
import ButtonLogout from "../Buttons/ButtonLogout";
import React from "react";
import {useTheme} from "@mui/material/styles";
import Images from "../../assets/images";
import {FiMenu} from "react-icons/fi";

interface Props {
    toggleNavBar: () => void
    pageTitle: string
}

const TopBar = ({toggleNavBar, pageTitle}: Props) => {
    const theme = useTheme();

    return (
        <AppBar
            sx={{
                backgroundColor: theme.palette.greenSoft.main,
                boxShadow: 'none',
            }}
        >
            <Toolbar
                sx={{
                    justifyContent: "space-between",
                    alignItems: "center"
                }}
            >
                <IconButton onClick={toggleNavBar}>
                    <FiMenu size={24} color={"white"}/>
                </IconButton>
                <img src={Images.logoHeader} alt={'main_logo'} style={{width: '8%', height: 'auto'}}/>
                <Stack direction={"row"} alignItems={"center"}>
                    <Typography sx={{
                        color: 'white',
                        textTransform: 'uppercase',
                        fontFamily: 'fantasy'
                    }}>{pageTitle} | </Typography>
                    <ButtonLogout
                        logoutIcon={<VscSignOut/>}
                        disableElevation={true}
                    />
                </Stack>
            </Toolbar>
        </AppBar>
    )
}

export default TopBar;
